import React, { useEffect, useRef } from 'react';
import './Banner.css';

const Banner = () => {
  const videoRef = useRef(null);

  useEffect(() => {
    const video = videoRef.current;
    if (!video) return;
    // Force-set muted at the DOM level — iOS Safari sometimes ignores
    // React's JSX `muted` prop, which causes autoplay to fail silently.
    video.muted = true;
    video.defaultMuted = true;
    video.setAttribute('muted', '');
    video.setAttribute('playsinline', '');
    const result = video.play();
    if (result && typeof result.catch === 'function') {
      result.catch(() => {
        /* Autoplay blocked — will play on user interaction */
      });
    }
  }, []);

  const scrollToContact = () => {
    const section = document.getElementById('contact');
    if (section) {
      const headerHeight = 80;
      const sectionTop = section.offsetTop - headerHeight;
      window.scrollTo({ top: sectionTop, behavior: 'smooth' });
    }
  };

  return (
    <section className="banner">
      <div className="banner-media">
        <video
          ref={videoRef}
          className="banner-video"
          src="/banner-hero.mp4"
          poster="/banner-hero-poster.jpg"
          autoPlay
          muted
          loop
          playsInline
          preload="auto"
          aria-hidden="true"
        />
      </div>

      <div className="banner-overlay">
        <div className="banner-content">
          <span className="banner-eyebrow reveal">Soft launching in Chicago</span>
          <h1 className="banner-headline display reveal reveal-delay-1">
            Know every <em>regular.</em><br />
            Reach every one.
          </h1>
          <p className="banner-tagline reveal reveal-delay-2">
            The community app for shops with regulars.
          </p>
          <button className="banner-cta reveal reveal-delay-3" onClick={scrollToContact}>
            Become a founding partner →
          </button>
        </div>
      </div>
    </section>
  );
};

export default Banner;
